<template>
  <div class="page">
    <page-header />
    <div class="page-body">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </div>

    <fix-tool />

    <page-footer ref="pageFooter" />
  </div>
</template>

<script>
// 组件
import PageHeader from '@/layout/components/PageHeader'
import PageFooter from '@/layout/components/PageFooter'
import FixTool from '@/layout/components/FixTool'

export default {
  name: 'DefaultLayout',

  components: { PageHeader, PageFooter, FixTool },
  data() {
    return {}
  },

  computed: {
    cachedViews() {
      return this.$store.state.cacheView.cachedViews
    },

    key() {
      return this.$route.path
    }
  },
  watch: {},
  created() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
.page {
  min-width: $body-width;
  min-height: 100vh;
  position: relative;
  padding-top: $header-height;

  .page-body {
    min-height: calc(100vh - #{$header-height});
    position: relative;
  }
}
</style>
